import * as React from 'react';
import swal from 'sweetalert';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import { useDispatch } from "react-redux";
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import DeleteIcon from '@mui/icons-material/Delete';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import { Stack, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReleaseNoteModal from './ReleaseNoteModal';
import DownloadIcon from '@mui/icons-material/Download';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { deleteUnitsAndEmums,downloadUnitFile,setLatestUnitsAndEmums } from '../api/unitsandenumsapi';
import {  useNavigate } from 'react-router-dom';

const columns = [
  { id: 'fileName', label: 'File Name' },
  { id: 'isLatest', label: 'Is Latest' },
  { id: 'actions', label: 'Actions'}
];

export default function UnitsAndEnums({rowsPerPage,page,handleChangePage,handleChangeRowsPerPage,filesList}) {
  
  const dispatch        = useDispatch();
  const navigate        = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [releaseNotes,setReleaseNotes] = React.useState('');
  

  const handleDelete = (id,isLatest) => {
    if(isLatest === "Yes"){
      swal("Warning", "Latest file can not be deleted ", "warning");   
      return;
    }
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete Units File!",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    })
    .then(willDelete => {
      if (willDelete) {
        dispatch(deleteUnitsAndEmums(id));
      }
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    setOpen(false);
  };

  const handleLatestUpdate =(rowId) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to change the Latest File!",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    })
    .then(willDelete => {
      if (willDelete) {
        dispatch(setLatestUnitsAndEmums(rowId));
      }
    });
    
  };

  const handleRedirectEdit = (id) => {
    navigate('/web/units/edit/'+id);
  }

  const handleFileDownload =(rowId,fileName) => {
    dispatch(downloadUnitFile(rowId,fileName));
  };

  return (
    <>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filesList?.records?.length > 0 ? filesList?.records.map((row,i) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                        <TableCell key={column.id} align={column.align}>
                              {column.format && typeof value === 'number'
                                ? column.format(value)
                                : 
                                column.id === 'actions' ?
                                <>
                                <Stack spacing={2} direction="row">
                                  <Tooltip title="View Release Notes">
                                    <VisibilityIcon 
                                      onClick={()=> handleClickOpen(setReleaseNotes(row.releaseNotes))}
                                      sx={{cursor:'pointer'}}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Download File">
                                    <DownloadIcon 
                                      onClick={(e) => handleFileDownload(row['id'],row['fileName'])}
                                      sx={{cursor:'pointer',color:"#2B7FFF"}}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Delete">
                                    <DeleteIcon onClick={(e)=> handleDelete(row.id,row.isLatest)} color="error" sx={{cursor:'pointer'}} />
                                 </Tooltip>
                                 {row?.isLatest === "No" &&
                                  <Tooltip title="Make Latest">
                                      <SettingsBackupRestoreIcon onClick={(e)=> handleLatestUpdate(row.id)} sx={{cursor:'pointer'}} />
                                  </Tooltip>
                                  }
                                  {row?.isLatest === "Yes" &&
                                  <Tooltip title="Edit">
                                      <EditIcon onClick={(e)=> handleRedirectEdit(row.id)} sx={{cursor:'pointer',color:"#2B7FFF"}} />
                                  </Tooltip>
                                  }
                                </Stack>
                              </>
                            : value}
                          </TableCell>
                    );
                  })}
                </TableRow>
              );
            }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
      {filesList?.total > 0 ?
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={filesList?.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage} />
        : <></>}
    </Paper>  
    <ReleaseNoteModal
        open={open}
        onClose={handleClose}
        description={releaseNotes}
      />
    </>
  );
}

